import { Typography } from '@mui/material';
import parseMoneyValue from '@utils/parseMoneyValue';
import { AffiliationMarketProductProps } from './AffiliationMarketProductCard';

type AffiliationMarketProductInfoProps = AffiliationMarketProductProps & {
  descriptionLabel: string;
};

export const AffiliationMarketProductInfo = (
  props: AffiliationMarketProductInfoProps,
) => {
  const { product, descriptionLabel } = props;

  return (
    <div className="grid m-sm gap-sm text-left">
      {product.description && (
        <>
          <Typography component="h4">{descriptionLabel}</Typography>
          <Typography className="text-lightBlack whitespace-pre-line break-word">
            {product.description}
          </Typography>
        </>
      )}
      <Typography>
        Taxa de comissão:{' '}
        <Typography component="span" className="text-lightBlack">
          {(product.commissionRate * 100).toFixed(0)}%
        </Typography>
      </Typography>
      <Typography>
        Comissões de até:{' '}
        <Typography component="span" className="text-lightBlack">
          {parseMoneyValue(product.maxCommissionValue)}
        </Typography>
      </Typography>
      {product.supportContact && (
        <>
          <Typography>
            Contato do responsável pelas afiliações:{' '}
            <Typography component="span" className="text-lightBlack">
              {product.supportContact}
            </Typography>
          </Typography>
        </>
      )}
    </div>
  );
};
